import { createAsyncThunk } from '@reduxjs/toolkit';
import { MpOrdersMarkingApi } from '@/Api/MpOrdersMarking/MpOrdersMarkingApi';
import {
  ChangeOrderDeliveryStatusByMarkerRequest,
  ChangeOrderDeliveryStatusPartiallyByMarkerRequest,
} from '@/Api/MpOrdersMarking/Requests';
import { OrderModel } from '@/Models/Order/OrderModel';

const changeDeliveryShippedStatus = createAsyncThunk<OrderModel[], ChangeOrderDeliveryStatusByMarkerRequest>(
  'changeDeliveryModal/change-delivery-shipped-status',
  async (request) => {
    return MpOrdersMarkingApi.changeDeliveryStatus(request);
  },
);

const changeDeliveryNotShippedStatus = createAsyncThunk<OrderModel[], ChangeOrderDeliveryStatusByMarkerRequest>(
  'changeDeliveryModal/change-delivery-not-shipped-status',
  async (request) => {
    return MpOrdersMarkingApi.changeDeliveryStatus(request);
  },
);

const changeDeliveryStatusPartially = createAsyncThunk<OrderModel[], ChangeOrderDeliveryStatusPartiallyByMarkerRequest>(
  'changeDeliveryModal/change-delivery-status-partially',
  async (request) => {
    return MpOrdersMarkingApi.changeDeliveryStatusPartially(request);
  },
);

export const changeDeliveryAsyncActions = {
  changeDeliveryShippedStatus,
  changeDeliveryNotShippedStatus,
  changeDeliveryStatusPartially,
};
